import { Component, Input, OnInit } from '@angular/core';
import { AdditionalSectionCard } from 'src/app/model/card/additional-section-card';

declare function multipleItems(): any;
@Component({
  selector: 'app-additional-page-carousel-section',
  templateUrl: './additional-page-carousel-section.component.html',
  styleUrls: ['./additional-page-carousel-section.component.scss']
})
export class AdditionalPageCarouselSectionComponent implements OnInit {
  constructor() {}

  @Input() additionalCarousalSectionCards: AdditionalSectionCard[] = [];
  @Input() headImage: string = '';
  @Input() title: string = '';
  @Input() seeAllNews: string = '';
  @Input() newsUrl: string = '';

  ngOnInit(): void {
    console.log('additionalSectionCards', this.additionalCarousalSectionCards);
    multipleItems();
  }
}
